import { MenuItem, Select } from '@mui/material';
import ScheduleList from '@src/components/template/admin/BookingPlaces/ScheduleList';
import placeApi from '@src/services/api/place';
import { useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  > div {
    > p {
      margin-bottom: 10px;
    }
    ~ div {
      margin-top: 20px;
    }
    > div {
      width: 100%;
    }
  }
`;

const NOT_DISPLAY_PLACE = ['1020094'];

type SelectItemType = {
  key: string;
  label: string;
};

export default function SearchSchedule() {
  const [placeList, setPlaceList] = useState<SelectItemType[]>();
  const [selectedPlaceId, setSelectedPlaceId] = useState<string>();
  const [itemList, setItemList] = useState<SelectItemType[]>();
  const [selectedItemId, setSelectedItemId] = useState<string>();

  const getPlaceList = async () => {
    try {
      const { data } = await placeApi.getList();
      setPlaceList(
        data
          .filter(place => !NOT_DISPLAY_PLACE.some(id => id === place.business_id))
          .map(place => ({ key: place.business_id, label: place.business_name })),
      );
    } catch (error) {}
  };

  const getItemList = async (bizId: string) => {
    const { data } = await placeApi.getBizItemsList(bizId);
    setItemList(data.map(item => ({ key: item.item_id, label: item.name })));
  };

  useEffect(() => {
    if (!selectedPlaceId) {
      return;
    }
    getItemList(selectedPlaceId);
    setSelectedItemId('');
  }, [selectedPlaceId]);

  useLayoutEffect(() => {
    getPlaceList();
  }, []);

  return (
    <Container>
      <div>
        <p>테니스장</p>
        <Select
          value={selectedPlaceId}
          onChange={event => setSelectedPlaceId(event.target.value as string)}
          size="small"
        >
          {placeList?.map(place => (
            <MenuItem key={place.key} value={place.key}>
              {place.label}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div>
        <p>코트</p>
        <Select value={selectedItemId} size="small" onChange={event => setSelectedItemId(event.target.value as string)}>
          {itemList?.map(place => (
            <MenuItem key={place.key} value={place.key}>
              {place.label}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div>
        <p>날짜</p>
        {selectedItemId ? <ScheduleList itemId={selectedItemId} /> : <></>}
      </div>
      {/* <div>
        <p>시작시간</p>
        <Select
          value={selectedItemId}
          size="small"
          onChange={event => setSelectedItemId(event.target.value as string)}
        >
          {itemList?.map(place => (
            <MenuItem key={place.key} value={place.key}>
              {place.label}
            </MenuItem>
          ))}
        </Select>
      </div> */}
    </Container>
  );
}
